import GridList from '@material-ui/core/GridList';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const FlexContainer = styled.div`
    display: flex;
`;

export const PlaceholderCard = styled.div`
    margin: 0 8px;
    min-width: 300px;
    height: 0px !important;
    flex: 1;
`;

export const StyledGridList = styled(GridList)`
    margin-top: 8px !important;
    display: flex;
`;

export const Title = styled(Typography)`
    color: rgba(0, 0, 0, 0.87);
    flex: 1;
`;
